/* =====================================================================
   Aufsätze für die BESTEHENDE Kaufbox von carlumina.de
   ---------------------------------------------------------------------
   Zwei Aufpreis-Schritte: Sternendichte und Farbe der Lederkettelung.

   Ändert nichts am Original: hängt sich nach app.js ein, schiebt die
   Blöcke hinter die Set-Größe und schreibt Preis, Klarna-Rate und
   Knopfbeschriftung neu. Beide Angaben wandern als Positionseigenschaft
   mit an die Bestellung — sonst weiß die Werkstatt nicht, was zu bauen ist.

   WICHTIG: Beide Aufpreise laufen bewusst durch EINE Preisrechnung
   (preisAnzeigen). Zwei getrennte Skripte würden sich gegenseitig
   überschreiben und einen der beiden Aufpreise verschlucken.

   In der lokalen Vorschau (window.CL_VORSCHAU) wird nichts gesendet,
   sondern angezeigt, was gesendet würde.
   ===================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     0. Wo liegen die Bilder?
     Lokal im Unterordner `bilder/`, im Shopify-Theme flach in `assets/`.
     Statt zwei Fassungen zu pflegen, wird der Ordner aus dem eigenen
     <script src="…"> abgeleitet — dort, wo diese Datei liegt, liegen auch
     die Bilder.
     --------------------------------------------------------------- */
  var BILDPFAD = (function () {
    var eigenes = document.currentScript ||
      document.querySelector('script[src*="aufsaetze.js"]');
    var quelle = eigenes && eigenes.src ? eigenes.src : '';
    // Im Theme steht die Datei unter …/assets/aufsaetze.js → gleicher Ordner.
    if (quelle.indexOf('/assets/') > -1) return quelle.replace(/[^/]+$/, '');
    return 'bilder/';
  })();
  var bild = function (name) { return BILDPFAD + name; };

  /* ---------------------------------------------------------------
     0b. Vorher-Nachher-Regler für die SkyClean-Seite
     Eigenständig: Markup, Stil (in aufsaetze.css) und Bedienung liegen hier,
     damit auf der SkyClean-Seite nichts vom Theme angefasst werden muss.
     --------------------------------------------------------------- */
  function skycleanRegler() {
    var anker = document.querySelector('#buy .buy-perks') ||
                document.querySelector('#buy .buy-info');
    if (!anker || document.getElementById('sc-regler')) return;

    var block = document.createElement('div');
    block.className = 'sc-regler-block';
    block.innerHTML =
      '<div class="opt-label">Vorher und nachher</div>' +
      '<p class="cl-unter">Zieh den Regler und sieh den Unterschied — gleicher Sitz, ' +
      'einmal gesaugt.</p>' +
      '<div class="sc-regler" id="sc-regler">' +
        '<img class="sc-bild sc-vorher" src="' + bild('skyclean-vergleich-ohne.jpg') + '"' +
        ' alt="Autositz mit Krümeln und Staub, vor dem Saugen" draggable="false">' +
        '<div class="sc-schnitt" id="sc-schnitt">' +
          '<img class="sc-bild" src="' + bild('skyclean-vergleich-mit.jpg') + '"' +
          ' alt="Derselbe Autositz nach dem Saugen mit dem SkyClean" draggable="false">' +
        '</div>' +
        '<span class="sc-marke" id="sc-marke"><i></i></span>' +
        '<span class="sc-schild sc-links">ohne SkyClean</span>' +
        '<span class="sc-schild sc-rechts">mit SkyClean</span>' +
        '<input type="range" class="sc-schieber" id="sc-schieber" min="0" max="100" value="50"' +
        ' aria-label="Vergleich zwischen ungesaugtem und gesaugtem Sitz">' +
      '</div>';
    anker.parentNode.insertBefore(block, anker);

    var schnitt = block.querySelector('#sc-schnitt');
    var marke = block.querySelector('#sc-marke');
    var schieber = block.querySelector('#sc-schieber');

    function setze(wert) {
      // Die obere Hälfte wird beschnitten, die Marke wandert mit.
      schnitt.style.width = wert + '%';
      marke.style.left = wert + '%';
    }
    schieber.addEventListener('input', function () { setze(this.value); });

    // Ziehen mit Maus und Finger — der Schieber allein wäre auf dem Bild
    // schwer zu treffen.
    function ausPosition(x) {
      var r = block.querySelector('#sc-regler').getBoundingClientRect();
      var w = Math.max(0, Math.min(100, (x - r.left) / r.width * 100));
      schieber.value = w;
      setze(w);
    }
    var zieht = false;
    var flaeche = block.querySelector('#sc-regler');
    flaeche.addEventListener('pointerdown', function (e) {
      zieht = true; ausPosition(e.clientX); flaeche.setPointerCapture(e.pointerId);
    });
    flaeche.addEventListener('pointermove', function (e) { if (zieht) ausPosition(e.clientX); });
    flaeche.addEventListener('pointerup', function () { zieht = false; });
    flaeche.addEventListener('pointercancel', function () { zieht = false; });

    setze(50);
  }

  /* ---------------------------------------------------------------
     1. Einstellungen — hier stehen alle Preise und Zahlen
     --------------------------------------------------------------- */

  /* „bild" ist die Rückfallaufnahme (Fußraum im Auto, Rand nicht im Fokus).
     „jeFarbe" hält die Studioaufnahmen, sobald es sie gibt — dann zeigt das
     Sternenbild die gewählte Kettelung mit. Fehlt die Farbe dort, bleibt es
     beim Rückfallbild; es behauptet keine Randfarbe und ist damit ehrlich. */
  var STUFEN = [
    {
      id: 'standard', name: 'Standard', bild: bild('sterne-standard.jpg'),
      jeFarbe: {
        schwarz: bild('sterne-standard-schwarz.jpg'),
        rot: bild('sterne-standard-rot.jpg'),
        beige: bild('sterne-standard-beige.jpg'),
        blau: bild('sterne-standard-blau.jpg')
      },
      vorne: 45, hintenVon: 20, hintenBis: 25,
      aufpreis: { '2er': 0, '4er': 0 },
      text: 'Der klassische Nachthimmel. Ruhig und dezent.',
      kurz: 'Gleichmäßig verteilt, unaufdringlich'
    },
    {
      id: 'voll', name: 'Maximum', bild: bild('sterne-voll.jpg'), tipp: '',
      jeFarbe: {
        schwarz: bild('sterne-voll-schwarz.jpg'),
        rot: bild('sterne-voll-rot.jpg'),
        beige: bild('sterne-voll-beige.jpg'),
        blau: bild('sterne-voll-blau.jpg')
      },
      vorne: 85, hintenVon: 30, hintenBis: 45,
      aufpreis: { '2er': 2495, '4er': 3995 },
      // Unsichtbares Aufpreis-Produkt „Sternen-Upgrade Voll" — läuft als eigene
      // Warenkorbzeile mit, sonst würde der Aufpreis nie berechnet.
      variante: { '2er': 56816197927298, '4er': 56816197960066 },
      text: 'Deutlich dichter. Das Maximum, das die Technik hergibt. Der Fußraum leuchtet ' +
            'flächig statt punktuell.',
      kurz: 'Die dichteste Fassung, die wir bauen'
    }
  ];

  // Farbe der Lederkettelung (Randeinfassung). Schwarz ist der Standard,
  // die drei Sonderfarben kosten Aufpreis.
  // „bild" ist ein Ausschnitt aus Hassans Musterfoto — das reine Lederband mit
  // Naht, aus dem Original geschnitten. Fehlt ein Bild (Schwarz hat kein
  // Muster), wird der Farbton „ton" als Fläche gezeigt; die Auswahl sieht
  // dadurch trotzdem einheitlich aus.
  // Die Farbtöne sind aus dem Foto gemessen, nicht geschätzt.
  // „bild" = kleines Muster für die Auswahlreihe, „gross" = Beispielbild in der
  // Großansicht. Fehlt „gross", zeigt die Großansicht einen Hinweis statt eines
  // kaputten Bildes.
  var FARBEN = [
    { id: 'schwarz', name: 'Schwarz', ton: '#272727', standard: true,
      bild: bild('kettelung-schwarz.jpg'), gross: bild('kettelung-gross-schwarz.jpg'),
      aufpreis: { '2er': 0, '4er': 0 } },
    { id: 'rot', name: 'Rot', ton: '#bc2524', bild: bild('kettelung-rot.jpg'),
      gross: bild('kettelung-gross-rot.jpg'), aufpreis: { '2er': 495, '4er': 995 } },
    { id: 'beige', name: 'Beige', ton: '#baa289', bild: bild('kettelung-beige.jpg'),
      gross: bild('kettelung-gross-beige.jpg'), aufpreis: { '2er': 495, '4er': 995 } },
    { id: 'blau', name: 'Blau', ton: '#173f7c', bild: bild('kettelung-blau.jpg'),
      gross: bild('kettelung-gross-blau.jpg'), aufpreis: { '2er': 495, '4er': 995 } }
  ];

  // Unsichtbares Aufpreis-Produkt „Lederrand in Sonderfarbe" — gilt für alle drei
  // Sonderfarben, welche es ist, steht als Eigenschaft an der Zeile.
  /* Seit 04.08. ist die Farbe eine echte Shopify-VARIANTE, nicht mehr nur ein
     Textvermerk an der Zeile. Grund: Der Checkout zeigt ausschließlich das Bild
     der Variante — mit nur einer Variante je Set sah ein Beige-Besteller im
     Checkout womöglich Rot. Jede Farbe hat jetzt ihr eigenes Foto. */
  var FARB_VARIANTE = {
    'rot':   { '2er': 56822921232770, '4er': 56822921331074 },
    'beige': { '2er': 56822921265538, '4er': 56822921363842 },
    'blau':  { '2er': 56822921298306, '4er': 56822921396610 }
  };
  function farbVariante(f) {
    var e = FARB_VARIANTE[f && f.id];
    return e ? e[setGroesse()] : null;
  }

  // Die Varianten der Hauptmatten. Fällt die letzte davon aus dem Warenkorb,
  // müssen die Aufpreiszeilen mit verschwinden — allein ergeben sie keinen Sinn.
  var HAUPT_VARIANTEN = [56707565388162, 56707565420930];
  var AUFPREIS_VARIANTEN = [];
  Object.keys(FARB_VARIANTE).forEach(function (k) {
    AUFPREIS_VARIANTEN.push(FARB_VARIANTE[k]['2er'], FARB_VARIANTE[k]['4er']);
  });
  STUFEN.forEach(function (s) {
    if (!s.variante) return;
    AUFPREIS_VARIANTEN.push(s.variante['2er'], s.variante['4er']);
  });

  // Erklärbild über den Farben: AUS. Die Leiste zeigte Rot, Beige und Blau —
  // dieselben drei Farben, die direkt darunter noch einmal als Auswahlfelder
  // stehen. Doppelt. Die Felder tragen jetzt echtes Leder, das reicht.
  // Pfad eintragen = Bild erscheint wieder.
  var KETTELUNG_ERKLAERBILD = '';

  /* Klartext unter den Set-Größen. Die Kaufbox selbst bleibt unangetastet —
     der Text wird erst hier ersetzt. Auf false setzen, dann steht wieder
     wortwörtlich das da, was heute live ist. */
  var SET_TEXTE_DEUTLICHER = true;
  var SET_TEXTE = {
    '2er': '189,95 € · nur vorne: Fahrer + Beifahrer',
    '4er': '219,95 € · alle vier Fußräume – nur 30 € mehr'
  };

  /* ---------------------------------------------------------------
     2. Anker in der bestehenden Kaufbox
     --------------------------------------------------------------- */
  var sets = document.getElementById('cfg-sets');
  var cta = document.getElementById('cfg-cta');

  /* Die SkyClean-Seite hat keinen Konfigurator, aber ihren eigenen
     Vorher-Nachher-Regler. Der Abschnitt „vergleich-slider" des Themes taugt
     dafür nicht: Beide Produkte teilen sich EINE Vorlage, und der Abschnitt
     ist fest auf die SkyMats begrenzt — eine zweite Instanz würde auf beiden
     Seiten erscheinen. Deshalb steht der Regler hier. */
  if (!sets || !cta) {
    if (location.pathname.indexOf('skyclean') > -1) skycleanRegler();
    return;
  }

  if (SET_TEXTE_DEUTLICHER) {
    Array.prototype.forEach.call(sets.querySelectorAll('.swatch'), function (sw) {
      var klein = sw.querySelector('small');
      if (klein) klein.textContent = SET_TEXTE[sw.textContent.indexOf('2er') > -1 ? '2er' : '4er'];
    });
  }

  var gewaehlteStufe = 'standard';
  var gewaehlteFarbe = 'schwarz';

  /* ---------------------------------------------------------------
     3. Hilfsmittel
     --------------------------------------------------------------- */
  var eur = function (cent) {
    return (cent / 100).toFixed(2).replace('.', ',') + ' €';
  };
  var finde = function (liste, id) {
    return liste.filter(function (e) { return e.id === id; })[0] || liste[0];
  };
  var stufe = function () { return finde(STUFEN, gewaehlteStufe); };
  var farbe = function () { return finde(FARBEN, gewaehlteFarbe); };

  var aktiverSwatch = function () {
    return sets.querySelector('.swatch.active') || sets.querySelector('.swatch');
  };
  // Die Kaufbox kennt nur „2er Set" / „4er Set" im Text — daran hängt alles Weitere.
  var setGroesse = function () {
    var s = aktiverSwatch();
    return s && s.textContent.indexOf('2er') > -1 ? '2er' : '4er';
  };
  var aufpreis = function (eintrag) {
    return (eintrag.aufpreis && eintrag.aufpreis[setGroesse()]) || 0;
  };

  /* ---------------------------------------------------------------
     4. Blöcke bauen und hinter die Set-Größe schieben
     --------------------------------------------------------------- */
  var block = document.createElement('div');
  block.className = 'cl-aufsaetze';
  /* Reihenfolge: erst die Kettelfarbe, dann die Sternendichte.
     Grund: die Sternenbilder sollen die gewählte Kettelung mitzeigen — die
     Farbe muss also feststehen, bevor der Kunde die Dichte vergleicht. */
  block.innerHTML =
    '<div class="opt-label">Farbe des Lederrands</div>' +
    (KETTELUNG_ERKLAERBILD
      ? '<figure class="cl-erklaer">' +
        // Fehlt die Datei, verschwindet der ganze Block statt ein kaputtes Bild zu zeigen.
        '<img src="' + KETTELUNG_ERKLAERBILD + '" alt="Lederrand in Rot, Beige und Blau an der Mattenkante"' +
        ' loading="lazy" onerror="this.closest(\'figure\').remove()">' +
        '<figcaption>So läuft der Lederrand um die Mattenkante, hier in Rot, Beige und Blau.</figcaption>' +
        '</figure>'
      : '') +
    '<div class="cl-farben" id="cl-farben" role="radiogroup" aria-label="Farbe des Lederrands"></div>' +
    /* Öffner für die Großansicht. Steht bewusst AUSSERHALB von #cl-farben: dessen
       Inhalt wird bei jedem Farbwechsel neu geschrieben, ein Knopf darin würde
       seinen Klick-Handler verlieren. Der Stil dazu liegt fertig in aufsaetze.css
       (.cl-lupe) — bis 05.08.2026 fehlte nur dieses Element, dadurch war die
       ganze Großansicht für Kunden unerreichbar. */
    '<button type="button" class="cl-lupe" id="cl-lupe">Lederrand aus der N\u00e4he ansehen</button>' +
    '<p class="cl-fuss" id="cl-farbe-fuss"></p>' +

    '<div class="opt-label cl-abstand">Wie viele Sterne?</div>' +
    '<p class="cl-unter" id="cl-dichte-unter"></p>' +
    /* Die Fußnote „Beispielaufnahmen — …" stand hier bis 05.08.2026. Raus auf
       Wunsch: dass Handarbeit nie zweimal gleich ausfällt, steht schon im
       Beschreibungstext der Karten. */
    '<div class="cl-dichte" id="cl-dichte" role="radiogroup" aria-label="Wie viele Sterne?"></div>';
  sets.parentNode.insertBefore(block, sets.nextSibling);

  var dichteGitter = block.querySelector('#cl-dichte');
  var farbGitter = block.querySelector('#cl-farben');
  var farbFuss = block.querySelector('#cl-farbe-fuss');

  /* Alles oder nichts: die farbeigenen Aufnahmen werden erst genutzt, wenn BEIDE
     Dichtestufen sie haben. Sonst stünde eine Studioaufnahme neben einer alten —
     und der Kunde vergliche zwei Bilder, die sich nicht nur in den Sternen
     unterscheiden. */
  var hatFarbBilder = function () {
    return STUFEN.every(function (s) { return s.jeFarbe && s.jeFarbe[gewaehlteFarbe]; });
  };
  function sternBild(s) {
    return hatFarbBilder() ? s.jeFarbe[gewaehlteFarbe] : s.bild;
  }

  function zeichneDichte() {
    var unter = document.getElementById('cl-dichte-unter');
    if (unter) {
      unter.textContent = hatFarbBilder()
        ? 'Dieselbe Matte bei Nacht, mit deinem Lederrand in ' + farbe().name + '.'
        : 'Dieselbe Matte bei Nacht.';
    }

    dichteGitter.innerHTML = STUFEN.map(function (s) {
      var auf = aufpreis(s);
      return '<div class="cl-d' + (s.id === gewaehlteStufe ? ' aktiv' : '') + '" data-wahl="' + s.id + '"' +
             ' role="radio" tabindex="0" aria-checked="' + (s.id === gewaehlteStufe) + '">' +
             (s.tipp ? '<span class="cl-d-tipp">' + s.tipp + '</span>' : '') +
             '<img src="' + sternBild(s) + '" alt="' + s.name + ': ' + s.vorne + ' Sterne je Vordermatte" loading="lazy">' +
             '<div class="cl-d-txt">' +
               '<div class="cl-d-kopf"><b>' + s.name + '</b>' +
               '<span class="cl-preis' + (auf ? '' : ' inkl') + '">' +
               (auf ? 'nur ' + eur(auf).replace(' ', '\u00a0') + ' mehr' : 'inklusive') + '</span></div>' +
               // Bewusst OHNE Sternenzahl: die Fotos sind Beispielaufnahmen und
               // treffen die gefertigte Zahl nicht auf den Punkt. Eine genannte
               // Zahl wäre eine Zusage, die das Bild daneben nicht hält.
               // Die exakten Zahlen stehen auf dem Bestellzettel — siehe eigenschaften().
               '<span class="cl-d-anzahl">' + s.kurz + '</span>' +
               '<span class="cl-d-beschr">' + s.text + '</span>' +
             '</div></div>';
    }).join('');

  }

  /* Eine Reihe Muster statt vier Karten. Vier volle Zeilen für eine Farbwahl
     lassen den Konfigurator länger wirken, als er ist — Name und Preis stehen
     deshalb nur für die GEWÄHLTE Farbe daneben. */
  function zeichneFarben() {
    var muster = FARBEN.map(function (f) {
      // Farbton IMMER als Grundfläche, das Foto nur darüber: fehlt die
      // Bilddatei, bleibt die Farbe stehen statt eines leeren Kastens.
      var flaeche = 'background-color:' + f.ton +
        (f.bild ? ';background-image:url(' + f.bild + ')' : '');
      return '<span class="cl-f' + (f.id === gewaehlteFarbe ? ' aktiv' : '') + '" data-wahl="' + f.id + '"' +
             ' role="radio" tabindex="0" aria-checked="' + (f.id === gewaehlteFarbe) + '"' +
             ' aria-label="' + f.name + '" title="' + f.name + '" style="' + flaeche + '"></span>';
    }).join('');

    var f = farbe();
    var auf = aufpreis(f);
    farbGitter.innerHTML =
      '<span class="cl-f-reihe">' + muster + '</span>' +
      '<span class="cl-f-wahl"><b>' + f.name + '</b>' +
      '<span class="cl-preis' + (auf ? '' : ' inkl') + '">' +
      (auf ? '+ ' + eur(auf) : 'im Preis enthalten') + '</span></span>';

    // Der Fachbegriff steht bewusst nur hier, klein und einmal: wer ihn kennt,
    // erkennt das Produkt wieder — verstehen muss ihn niemand.
    farbFuss.textContent = f.standard
      ? 'Der Lederrand (Kettelung) fasst die Matte rundum ein und schützt die Kante.'
      // Wer eine Sonderfarbe wählt, rechnet mit Wartezeit — der Satz nimmt den Zweifel weg.
      : f.name + ' ist eine Sonderfarbe. Die Lieferzeit bleibt dieselbe.';
  }

  /* ---------------------------------------------------------------
     5. Preis — EINE Rechnung für beide Aufsätze
     app.js setzt Preis, Rate und Knopf beim Wechsel der Set-Größe.
     Wir laufen danach und rechnen alle Aufpreise drauf.
     --------------------------------------------------------------- */
  function preisAnzeigen() {
    var swatch = aktiverSwatch();
    if (!swatch) return;
    var summe = (+swatch.dataset.price || 0) + aufpreis(stufe()) + aufpreis(farbe());

    var preisEl = document.querySelector('#buy .price');
    var rateEl = document.getElementById('cfg-rate');
    if (preisEl) preisEl.textContent = eur(summe);
    if (rateEl) rateEl.textContent = eur(Math.round(summe / 3));
    cta.textContent = 'In den Warenkorb';   // Preis steht im Kasten darueber

    /* Die mitlaufende Leiste am unteren Rand setzt app.js nur beim Wechsel der
       Set-Größe. Ohne diese Zeile stand dort weiter 219,95 €, während oben
       längst der Preis mit Aufpreisen zu sehen war. Geschrieben wird nur die
       Zahl — die Zeile darunter ist seit dem Umbau fester Text im Markup. */
    var leiste = document.querySelector('.sticky-preis');
    if (leiste) leiste.textContent = eur(summe);
  }

  function alles() { zeichneDichte(); zeichneFarben(); preisAnzeigen(); }

  /* ---------------------------------------------------------------
     6. Bedienung
     --------------------------------------------------------------- */
  function verdrahte(gitter, setzen) {
    function waehle(ev) {
      var karte = ev.target.closest('[data-wahl]');
      if (!karte) return;
      if (ev.type === 'keydown') {
        if (ev.key !== 'Enter' && ev.key !== ' ') return;
        ev.preventDefault();
      }
      setzen(karte.dataset.wahl);
      alles();
    }
    gitter.addEventListener('click', waehle);
    gitter.addEventListener('keydown', waehle);
  }
  verdrahte(dichteGitter, function (v) { gewaehlteStufe = v; });
  verdrahte(farbGitter, function (v) { gewaehlteFarbe = v; });

  /* ---------------------------------------------------------------
     6b. Großansicht
     Ein Textknopf statt einer weiteren Bildreihe: wer die Kettelung genauer
     sehen will, bekommt sie groß — alle anderen sehen nur eine Zeile mehr.
     --------------------------------------------------------------- */
  var lupe = null;

  function lupeZeichnen() {
    if (!lupe) return;
    var f = farbe();
    var auf = aufpreis(f);
    lupe.querySelector('.cl-lupe-bild').innerHTML = f.gross
      ? '<img src="' + f.gross + '" alt="Lederrand in ' + f.name + ' an der Mattenkante">'
      : '<div class="cl-lupe-leer" style="background:' + f.ton + '"></div>' +
        '<p class="cl-lupe-hinweis">Von dieser Farbe liegt noch kein Beispielbild vor.</p>';
    lupe.querySelector('.cl-lupe-name').textContent = f.name;
    lupe.querySelector('.cl-lupe-preis').textContent = auf ? '+ ' + eur(auf) : 'im Preis enthalten';
    lupe.querySelectorAll('.cl-lupe-wahl [data-wahl]').forEach(function (el) {
      el.classList.toggle('aktiv', el.dataset.wahl === gewaehlteFarbe);
    });
  }

  function lupeOeffnen() {
    if (!lupe) {
      lupe = document.createElement('div');
      lupe.className = 'cl-lupe-schicht';
      lupe.setAttribute('role', 'dialog');
      lupe.setAttribute('aria-modal', 'true');
      lupe.setAttribute('aria-label', 'Lederrand in Großansicht');
      lupe.innerHTML =
        '<div class="cl-lupe-kasten">' +
          '<button type="button" class="cl-lupe-zu" aria-label="Schließen">&times;</button>' +
          '<div class="cl-lupe-bild"></div>' +
          '<div class="cl-lupe-kopf">' +
            '<b class="cl-lupe-name"></b><span class="cl-lupe-preis cl-preis"></span>' +
          '</div>' +
          '<div class="cl-lupe-wahl">' +
            FARBEN.map(function (f) {
              var flaeche = 'background-color:' + f.ton +
                (f.bild ? ';background-image:url(' + f.bild + ')' : '');
              return '<span class="cl-f" data-wahl="' + f.id + '" role="button" tabindex="0"' +
                     ' aria-label="' + f.name + '" title="' + f.name + '" style="' + flaeche + '"></span>';
            }).join('') +
          '</div>' +
          '<p class="cl-lupe-fuss">Der Lederrand läuft rundum um die Matte. ' +
          'Die Auswahl gilt für alle Matten deines Sets.</p>' +
        '</div>';
      document.body.appendChild(lupe);

      lupe.addEventListener('click', function (ev) {
        if (ev.target === lupe || ev.target.closest('.cl-lupe-zu')) { lupeSchliessen(); return; }
        var w = ev.target.closest('[data-wahl]');
        if (w) { gewaehlteFarbe = w.dataset.wahl; alles(); lupeZeichnen(); }
      });
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape') lupeSchliessen();
      });
    }
    lupeZeichnen();
    lupe.classList.add('offen');
    document.body.style.overflow = 'hidden';
  }

  function lupeSchliessen() {
    if (!lupe) return;
    lupe.classList.remove('offen');
    document.body.style.overflow = '';
  }

  var lupenKnopf = document.getElementById('cl-lupe');
  if (lupenKnopf) lupenKnopf.addEventListener('click', lupeOeffnen);

  // Auf dem Container: läuft nach den Klick-Handlern der einzelnen Swatches.
  sets.addEventListener('click', function () { setTimeout(alles, 0); });

  /* ---------------------------------------------------------------
     7. Eigenschaften an die Bestellung hängen
     Der Kaufknopf der Kaufbox schickt selbst an /cart/add.js. Statt seinen
     Code anzufassen, ergänzen wir die Anfrage unterwegs.
     --------------------------------------------------------------- */
  function eigenschaften() {
    var s = stufe(), f = farbe();
    return {
      /* Bewusst OHNE Stueckzahl (05.08.2026): Auf der Seite steht bei „Maximum"
         absichtlich keine feste Anzahl, weil jede Matte von Hand gefertigt wird.
         Auf der Rechnung stand bisher „vorne 85, hinten 30–45 je Matte" — das
         waere ein Versprechen, das die Handarbeit nicht garantieren kann.
         Fuer die Fertigung genuegt die Stufe. */
      'Sternendichte': s.name,
      'Lederrand (Kettelung)': f.name + (f.standard ? ' (Standard)' : ' (Sonderfarbe)')
    };
  }

  /* Die Aufpreise als EIGENE Warenkorbzeilen. Shopify kann einer Position keinen
     freien Aufpreis geben — ohne diese Zeilen wäre der Aufpreis bloße Anzeige und
     der Kunde bekäme beide Aufsätze geschenkt. Nebeneffekt: auf der Rechnung
     steht jeder Aufsatz einzeln, statt in einer Sammelposition zu verschwinden. */
  function aufpreisZeilen() {
    var zeilen = [];
    var s = stufe(), f = farbe();

    /* Kein `properties: { Farbe: … }` mehr: Die Variante heißt schon
       „4er Set / Beige", der Vermerk stünde doppelt in der Bestellung. */
    if (aufpreis(f) && farbVariante(f)) {
      zeilen.push({ id: farbVariante(f), quantity: 1 });
    }
    if (aufpreis(s) && s.variante && s.variante[setGroesse()]) {
      zeilen.push({ id: s.variante[setGroesse()], quantity: 1 });
    }
    return zeilen;
  }

  /* Entfernt der Kunde die Matten, müssen die Aufpreiszeilen mitgehen.
     Statt hinterherzuräumen wird die Entfernen-Anfrage umgeschrieben: aus
     „diese eine Zeile auf 0" wird „diese Zeile UND die Aufpreise auf 0".
     Damit sieht die Schublade sofort den richtigen Stand — sie zeichnet
     unmittelbar nach dieser Antwort neu. */
  function alsAufraeumenUmschreiben(schluessel) {
    return echtesFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (korb) {
        var betroffen = korb.items.filter(function (i) { return i.key === schluessel; })[0];
        if (!betroffen || HAUPT_VARIANTEN.indexOf(betroffen.variant_id) < 0) return null;

        // Nur wenn KEINE weitere Mattenzeile übrig bleibt
        var restHaupt = korb.items.filter(function (i) {
          return i.key !== schluessel && HAUPT_VARIANTEN.indexOf(i.variant_id) > -1;
        });
        if (restHaupt.length) return null;

        var aenderungen = {};
        aenderungen[schluessel] = 0;
        korb.items.forEach(function (i) {
          if (AUFPREIS_VARIANTEN.indexOf(i.variant_id) > -1) aenderungen[i.key] = 0;
        });
        return echtesFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: aenderungen })
        });
      })
      .catch(function () { return null; });
  }

  var echtesFetch = window.fetch;
  window.fetch = function (ziel, optionen) {
    var url = typeof ziel === 'string' ? ziel : (ziel && ziel.url) || '';

    if (!window.CL_VORSCHAU && url.indexOf('/cart/change.js') > -1 && optionen && optionen.body) {
      var wunsch;
      try { wunsch = JSON.parse(optionen.body); } catch (e) { wunsch = null; }
      if (wunsch && Number(wunsch.quantity) === 0 && wunsch.id) {
        var derAufrufer = this;
        return alsAufraeumenUmschreiben(wunsch.id).then(function (antwort) {
          // `this` wäre hier nicht mehr der ursprüngliche Aufrufer — deshalb gemerkt.
          return antwort || echtesFetch.call(derAufrufer, ziel, optionen);
        });
      }
    }

    if (url.indexOf('/cart/add.js') > -1 && optionen && optionen.body) {
      var daten;
      try { daten = JSON.parse(optionen.body); } catch (e) { daten = null; }
      // Nur den Kaufklick der Kaufbox anfassen, nicht den SkyClean-Knopf in der
      // Warenkorb-Schublade — der schickt kein `properties` mit.
      if (daten && daten.properties) {
        daten.properties = daten.properties || {};
        var zusatz = eigenschaften();
        Object.keys(zusatz).forEach(function (k) { daten.properties[k] = zusatz[k]; });

        // Shopify zeigt die ZULETZT hinzugefügte Zeile oben. Damit die Matten
        // im Warenkorb obenauf liegen und die Aufpreise darunter, wird die
        // Reihenfolge hier umgedreht gesendet.
        var aufpreise = aufpreisZeilen().reverse();

        /* Zweiter (oder dritter…) Satz mit GLEICHER Ausstattung: assets/warenkorb-frei.js
           hat der Mattenzeile oben gerade eine Kennung ("_satz") verpasst, damit Shopify
           sie nicht mit dem ersten Satz zusammenlegt. Die Aufpreis-Zeilen hier bekamen
           bisher NIE eine Kennung -- zwei Sternen-Upgrades mit identischer (leerer)
           Eigenschaftenliste hat Shopify serverseitig sofort zu einer Zeile "2×"
           verschmolzen, noch bevor die Kennung nachtraeglich haette greifen koennen. Der
           Kunde sah dann eine Sammelzeile ohne erkennbaren Bezug zu einer bestimmten
           Matte. Deshalb hier direkt mitschicken, wenn vorhanden. */
        var satzKennung = daten.properties['_satz'];
        if (satzKennung) {
          aufpreise = aufpreise.map(function (z) {
            return Object.assign({}, z, { properties: { '_satz': satzKennung } });
          });
        }

        var alles = { items: aufpreise.concat([daten]) };
        optionen = Object.assign({}, optionen, { body: JSON.stringify(alles) });

        if (window.CL_VORSCHAU) {
          zeigeVorschau(alles);
          return Promise.resolve(new Response('{}', {
            status: 200, headers: { 'Content-Type': 'application/json' }
          }));
        }
      }
    }

    // Vorschau hat keinen echten Warenkorb — leere Antwort statt 404-Rauschen.
    if (window.CL_VORSCHAU && (url.indexOf('/cart.js') > -1 || url.indexOf('/cart/change.js') > -1)) {
      return Promise.resolve(new Response(
        JSON.stringify({ items: [], item_count: 0, total_price: 0 }),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      ));
    }

    // NICHT apply(this, arguments) verwenden: die Datei läuft im strengen Modus,
    // dort ist `arguments` von den Parametern entkoppelt. Ein überschriebenes
    // `optionen` käme damit nie an — genau das hat am 02.08. die Aufpreiszeilen
    // verschluckt, und zwar nur live, weil die Vorschau vorher abzweigt.
    return echtesFetch.call(this, ziel, optionen);
  };

  function zeigeVorschau(alles) {
    var kasten = document.getElementById('cl-vorschau-ausgabe');
    if (!kasten) {
      kasten = document.createElement('pre');
      kasten.id = 'cl-vorschau-ausgabe';
      kasten.className = 'cl-vorschau-ausgabe';
      cta.parentNode.insertBefore(kasten, cta.nextSibling);
    }

    var namen = { };
    Object.keys(FARB_VARIANTE).forEach(function (k) {
      namen[FARB_VARIANTE[k]['2er']] = 'Lederrand in Sonderfarbe (2er, ' + k + ')';
      namen[FARB_VARIANTE[k]['4er']] = 'Lederrand in Sonderfarbe (4er, ' + k + ')';
    });
    STUFEN.forEach(function (s) {
      if (!s.variante) return;
      namen[s.variante['2er']] = 'Sternen-Upgrade ' + s.name + ' (2er)';
      namen[s.variante['4er']] = 'Sternen-Upgrade ' + s.name + ' (4er)';
    });

    var text = 'Diese Zeilen gingen in den Warenkorb:\n';
    alles.items.forEach(function (zeile, i) {
      text += '\n' + (i === 0 ? 'SkyMats (Variante ' + zeile.id + ')' : namen[zeile.id] || ('Variante ' + zeile.id));
      Object.keys(zeile.properties || {}).forEach(function (k) {
        text += '\n    ' + k + ': ' + zeile.properties[k];
      });
    });

    var swatch = aktiverSwatch();
    text += '\n\nSumme: ' + eur((swatch ? +swatch.dataset.price || 0 : 0) +
                                 aufpreis(stufe()) + aufpreis(farbe()));
    kasten.textContent = text;
    kasten.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  /* ---------------------------------------------------------------
     8. Bilder in der Warenkorb-Schublade
     Die beiden Aufpreis-Produkte haben in Shopify kein Bild — im Warenkorb
     bliebe eine leere Fläche. Der Aufsatz setzt es selbst, beim Lederrand
     sogar in der bestellten Farbe. Das könnte ein einzelnes Produktbild
     gar nicht leisten, weil dieselbe Position für Rot, Beige und Blau gilt.
     --------------------------------------------------------------- */
  /* WICHTIG: Der Produktname wird NUR im Titel gesucht, nicht im ganzen
     Zeilentext. Die Mattenzeile führt „Lederrand (Kettelung): Rot" als Angabe
     mit — ein Textvergleich über die ganze Zeile würde ihr Produktfoto
     überschreiben. Die Farbe darf dagegen aus der ganzen Zeile kommen. */
  function bildFuerZeile(titel, text) {
    if (titel.indexOf('Lederrand in Sonderfarbe') > -1) {
      var treffer = FARBEN.filter(function (f) {
        return !f.standard && text.indexOf(f.name) > -1;
      })[0];
      return treffer ? treffer.bild : null;
    }
    if (titel.indexOf('Sternen-Upgrade') > -1) return bild('sterne-voll-schwarz.jpg');
    return null;
  }

  function schubladeNachbessern() {
    var liste = document.getElementById('cartItems');
    if (!liste) return;
    Array.prototype.forEach.call(liste.querySelectorAll('.cart-item'), function (zeile) {
      var titel = zeile.querySelector('b');
      if (!titel) return;
      var quelle = bildFuerZeile(titel.textContent, zeile.textContent);
      if (!quelle) return;
      var img = zeile.querySelector('img');
      // Vergleich verhindert eine Endlosschleife: das Setzen löst den
      // Beobachter erneut aus, beim zweiten Durchlauf passt der Wert schon.
      if (img && img.getAttribute('src') !== quelle) {
        img.setAttribute('src', quelle);
        img.style.opacity = '';
      }
    });
  }

  (function () {
    var liste = document.getElementById('cartItems');
    if (!liste || typeof MutationObserver !== 'function') return;
    new MutationObserver(schubladeNachbessern)
      .observe(liste, { childList: true, subtree: true });
    schubladeNachbessern();
  })();

  alles();
})();
